const config = { 
  gapi: {
    'apiKey': 'AIzaSyDZokhPful_TQKo0jjNrO6HBJwRubBDC9g',
    'clientId': '514982394042-bt4hv11jkc6nvm3n0id6je8mml2q4gl8.apps.googleusercontent.com',
    'scope': 'https://www.googleapis.com/auth/userinfo.email',
    'discoveryDocs': [
      'https://api-dot-ao-billing-platform-dev.appspot.com/_ah/api/discovery/v1/apis/billing/v1/rest'
    ]
  },
  debug: true
}

export default config;


// WEBPACK FOOTER //
// ./src/config.dev.js